export const messages = {
  en: {
    doHistoryComplaints: {
      title: 'Pending Complaint Orders',
      back: 'Back',
      refresh: 'Refresh',
      orderId: 'Order ID',
      complaintType: 'Complaint Type',
      house: 'House',
      complainer: 'Complainer',
      complaintPhone: 'Complaint Phone',
      complaintStatus: 'Complaint Status',
      createTime: 'Create Time',
      operation: 'Operation',
      detail: 'Detail',
      fetchError: 'Failed to fetch complaint data'
    }
  },
  zh: {
    doHistoryComplaints: {
      title: '待办投诉单',
      back: '返回',
      refresh: '刷新',
      orderId: '订单编号',
      complaintType: '投诉类型',
      house: '房屋',
      complainer: '投诉人',
      complaintPhone: '投诉电话',
      complaintStatus: '投诉状态',
      createTime: '创建时间',
      operation: '操作',
      detail: '详情',
      fetchError: '获取投诉数据失败'
    }
  }
}